import axios from 'axios'
import BackendService from '@/services/Backend'

const CancelToken = axios.CancelToken
let cancelFindProviders

class MasterdataService extends BackendService {
  constructor(baseUrl, interceptor) {
    super(baseUrl, '/masterdata/v1', interceptor)
  }

  getFranchises(language) {
    return this.get('franchises', {
      language,
    })
  }

  getLocations({ query, ...params }) {
    const payload = {
      q: (query || '').trim(),
      ...params,
    }
    return this.get('locations', payload)
  }

  getStreets({ street, zipcode }) {
    return this.get('/locations/streets', { street, zipcode })
  }

  getHouseNumbers({ housenumber, street, zipcode }) {
    return this.get('/locations/housenumbers', { housenumber, street, zipcode })
  }

  getHouseLocation({ housenumber, street, zipcode }) {
    return this.get('/locations/houselocation', { housenumber, street, zipcode })
  }

  getMovedFromAbroadReasons(language) {
    return this.get('moved-from-abroad', {
      language,
    })
  }

  getNoKVGReasons(language) {
    return this.get('no-kvg-reason', {
      language,
    })
  }

  getPreinsurers(params) {
    return this.get('preinsurers', params)
  }

  getReverseLocation({ lat, lng }) {
    return this.get('/locations/reversegeocode', { lat, lng })
  }

  /**
   * Find current care providers / medical office centers
   *
   * interface ProviderPayload {
   *   avmNetworks?: string[]             // AVM doctor networks
   *   contractStartDate: LocalDateTime
   *   limit?: number
   *   name?: string                      // Search query for the doctor name
   * }
   *
   * interface ProviderGeoPayload extends ProviderPayload {
   *   maxLat: number
   *   minLat: number
   *   maxLon: number
   *   minLon: number
   * }
   *
   * interface ProviderZipCodePayload extends ProviderPayload {
   *   zipCode: number
   * }
   *
   * interface ProviderResponse {
   *   data: Provider[]
   * }
   *
   * @param {ProviderGeoPayload | ProviderZipCodePayload} payload
   * @returns {Promise<ProviderResponse>}
   */
  findProviders({ query, ...params }) {
    if (cancelFindProviders) {
      cancelFindProviders()
    }

    const payload = {
      q: query,
      ...params,
      // An executor function receives a cancel function as a parameter
      cancelToken: new CancelToken(function executor(c) {
        cancelFindProviders = c
      }),
    }
    return this.post('/care-providers', payload)
  }
}

export default MasterdataService
